<template>
  <div>
    <div
      style="width: 90%; margin-bottom: 20px; margin-top: 25px; position: relative;"
      class="lk_content_info_block"
    >
      <div style="display: table-cell; width: 70px">
        <el-icon
          style="
            font-size: 50px;
            position: absolute;
            transform: rotate(180deg);
            left: 20px;
            color: #e82862;
          "
          ><Warning
        /></el-icon>
      </div>
      <div style="display: table-cell">
        <span v-html="infoBlock[store.langSelect.value]"></span>
      </div>
    </div>
    <div
      class="table"
      style="height: 300px; width: 700px"
      v-if="store.cryptoServerIsActived.value"
    >
      <div
        class="col"
        style="background-color: #f7f7f7; width: 359px; height: 300px"
      >
        <div
          style="padding-top: 50px; padding-left: 64px"
          v-if="tronCurrentError == ''"
        >
          <div style="margin-bottom: 20px">
            <div class="mylabel">
              {{ messages.account[store.langSelect.value] }}:
            </div>

            <div style="margin-top: 6px">
              <div class="myselector" style="width: calc(100% - 58px)">
                <el-select
                  v-model="inAccount"
                  icon-сlass="caret-top"
                  placeholder="Select"
                >
                  <el-option
                    v-for="(item, i) in accounts"
                    :key="i"
                    :label="item.Account"
                    :value="item.Account"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="margin-top: 18px">
              <el-input-number
                style="width: calc(100% - 58px)"
                v-model="depositUDT"
                controls-position="right"
                @change="DepositInputChange"
                :step="1"
                step-strictly
                :min="1"
                :max="depositAbsMaxUDT"
              ></el-input-number>
            </div>
            <div style="margin-top: 6px">
              <Button
                :text="depositTronButton[store.langSelect.value]"
                acolor="#f7f7f7"
                @click="DepositTron"
                :disabled="depositTronButtonDisabled"
              />
            </div>
            <div
              v-if="
                balanceUDT > 0 && balanceUSDT > 0 && account_info.MoneyFree > 1
              "
            >
              <div style="margin-top: 18px">
                <el-input-number
                  style="width: calc(100% - 58px)"
                  v-model="withdrawalUDT"
                  controls-position="right"
                  @change="WithdrawalInputChange"
                  :step="1"
                  step-strictly
                  :min="1"
                  :max="withdrawalAbsMaxUDT"
                >
                  <template #append>Max</template>
                </el-input-number>
              </div>
              <div style="margin-top: 6px">
                <Button
                  :text="withdrawalTronButton[store.langSelect.value]"
                  acolor="#f7f7f7"
                  @click="WithdrawalTron"
                  :timer="withdrawalButtonTimer"
                  timerview="true"
                  @disabledEvent="disabledWithdrawalTronButton"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-else style="padding-top: 50px; padding-left: 64px">
          {{ tronCurrentError }}
          <br /><br />
          <Button
            :text="errorTronLinkButton[store.langSelect.value]"
            acolor="#f7f7f7"
            @click="RefreshTronLink"
          />
        </div>
      </div>
      <div class="col" style="width: 82px; position: relative">
        <div style="position: absolute; left: 27px; top: 115px">
          <svg
            width="30"
            height="20"
            viewBox="0 0 30 2"
            preserveAspectRatio="xMidYMid meet"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1H29"
              stroke="#D4D9DD"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <svg
            width="10"
            height="20"
            viewBox="0 0 10 18"
            style="margin-left: -10px"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L9 9L1 17"
              stroke="#D4D9DD"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div
        class="col"
        style="
          background-color: #f7f7f7;
          width: 359px;
          min-height: 300px;
          position: absolute;
        "
      >
        <div
          style="padding-top: 50px; padding-left: 64px"
          v-if="balanceUDT > 0"
        >
          <div style="margin-bottom: 20px">
            <div class="mylabel">UDT:</div>
            <div style="margin-top: 10px">
              <span>{{ balanceUDT }}</span>
            </div>
          </div>
          <div style="margin-bottom: 20px">
            <div class="mylabel">Free:</div>
            <div style="margin-top: 10px">
              <span :class="{ warningvalue: account_info.MoneyFree < 1 }">{{
                account_info.MoneyFree
              }}</span>
            </div>
          </div>
          <div style="margin-bottom: 20px">
            <div class="mylabel">USDT:</div>
            <div style="margin-top: 10px">
              <span :class="{ warningvalue: balanceUSDT < 0 }">{{
                balanceUSDT
              }}</span>
            </div>
          </div>
        <!--  Max:{{ withdrawalAbsMaxUDT }} -->
        </div>
        <div class="rightInfoBlock" v-else>
          <span v-html="rightInfoBlock[store.langSelect.value]"></span>
        </div>
      </div>
    </div>
    <div
      style="width: 90%; margin-bottom: 20px; margin-top: 25px; position: relative;"
      class="lk_content_info_block"
      v-else
    >
      <div style="display: table-cell; width: 70px; height: 50px">
        <el-icon
          style="
            font-size: 50px;
            position: absolute;
            transform: rotate(180deg);
            left: 20px;
            color: #e82862;
          "
          ><Warning
        /></el-icon>
      </div>
      <div style="display: table-cell">
        <span v-html="cryptoServerIsNotActive[store.langSelect.value]"></span>
      </div>
      <Button
        text="Refresh"
        @click="CheckCrypto"
        @disabledEvent="disabledRefreshButtonEvent"
        :timer="refreshTimer"
        :disabled="disabledRefreshButton"
        :timerview="true"
      />
    </div>
    <div style="margin-top: 20px"></div>
    <div style="margin-top: 50px">
      <MoneyTransactionHistoryTable :account="inAccount">
        <template v-slot:mtthead="">
          <div class="th">Date</div>
          <div class="th">Currency</div>
          <div class="th">Value</div>
        </template>
        <template v-slot:mttbody="props">
          <div
            class="tr"
            v-if="props.item.src === 'admin' && props.item.cur == 'UDT'"
          >
            <div class="td">{{ getStringTime(props.item.m) }}</div>
            <div class="td">{{ props.item.cur }}</div>
            <div class="td" v-if="props.item.crd != 'system'">
              {{ props.item.val }}
            </div>
            <div class="td" v-if="props.item.crd === 'system'">
              {{ props.item.val * -1 }}
            </div>
          </div>
        </template>
      </MoneyTransactionHistoryTable>
   <!--   <Button
        :text="breachTronButton[store.langSelect.value]"
        acolor="#f7f7f7"
        @click="BreachTron"
      /> -->
    </div>
  </div>
</template>

<script>
import { reactive, ref, watch, computed } from "vue";
import { useMyStorage, getAccPositions, getAccInfo } from "@/store/global";
import { copyText } from "vue3-clipboard";
import MoneyTransactionHistoryTable from "./MoneyTransactionHistoryTable";

import SampleQrImage from "@/assets/sampleqr.png";
import SampleQrImageUSDT from "@/assets/sampleusdt.png";
import Button from "./Button";
import { Warning } from "@element-plus/icons-vue";
import { JSONCodec } from "nats.ws";
//import axios from "axios";
//import TronWeb from "tronweb"
//import { DocumentCopy } from "@element-plus/icons-vue";

export default {
  components: {
    MoneyTransactionHistoryTable,
    Button,
    //  DocumentCopy,
    Warning,
  },
  name: "DepositUDTComponent",
  setup() {
    const inAccount = ref("");
    const inCurrency = ref("");
    const store = useMyStorage();
    const accountsAddress = reactive(store.accountsAddress);
    const accounts = store.userInfo.value.Info.Accounts;
    const inInstrument = ref("");
    const accUsdtAddresIs = ref(false);
    const errorTronLinkButton = ref("");
    const qrcodeImage = ref(SampleQrImage);
    const qrcodeUstdImage = ref(SampleQrImageUSDT);
    const bitAddr = ref("");
    const usdtAddr = ref("It is not an address. TRC20 only");
    const connect = ref(store.mynats);
    const user = store.user.value;
    const CONTRACT = "TXLAQ63Xg1NAzckPwKHvzw7CSEmLMEqcdj"; //USDT
    const UDT = "TWQ3U3gWEhSApLW3iqqdwKMtEakVxVqk2G";
    const depositAbsMaxUDT = 10000;
    const depositTronButtonDisabled = ref(false);
    const serverCryptoActiv = ref(true);
    // const depositMax=0;
    const depositUDT = ref(0);
    const balanceUDT = ref(0);
    const balanceTRX = ref(0);
    const balanceUSDT = ref(0);
    const withdrawalUDT = ref(0);
    const withdrawalButtonTimer = ref(0);
    const refreshTimer = ref(0);
    const disabledRefreshButton = ref(false);
    const jc = JSONCodec();
    //   const accauntBalanceUSDT = ref(0);
    for (let i = 0; i < user.Accounts.length; i++) {
      // console.log(user.Accounts[i].Account);
      if (accountsAddress[user.Accounts[i].Account] == undefined) {
        accountsAddress[user.Accounts[i].Account] = {
          qrBTC: SampleQrImage,
          addressBTC: "It is not an address.",
          qrUSDT: SampleQrImageUSDT,
          addressUSDT: "It is not an address. TRC20 only",
          accUsdtAddresIs: false,
        };
      }
    //  store.TronSendAllToSigner(user.Accounts[i].Account)
      
    }
   // store.GetTronAccountBalances("AET253197")
 //  store.GetTronAccountBalances("AET601189")
 // store.TronSendAllToSigner("AET601189")
    const tronCurrentError = ref("");
    const tronError = [
      ["Расширение браузера TronLink не установлено", "TronLink not found"],
      ["Счёт не подключени в TronLink", "Account not actived in TronLink"],
      ["Выбрано не верная сеть в TronLink, выберите Nile", "Network err"],
      ["Не достаточно TRX", ""],
    ];
    const depositTronButton = ["Положить", "Deposit"];
    const withdrawalTronButton = ["Снять", "Withdrawal"];
    const breachTronButton = ["Breach", "Breach"];
    const selectedTronAccount = ref("");
    /*   const CheckRespons = async (msg) => {
     return msg.check;
    };
    const Check = async () => {
      
      const newCh = "tron-response-" + Math.random();
      store.MyNatsSubscribe(newCh,CheckRespons);
      await connect.value
        .request("tron", jc.encode({func: "Check"}), {
          timeout: 1000,
          noMux: true,
          reply: newCh,
        })
        .catch((err) => {
          console.log(`problem with request: ${err.message}`);
          return false;
        });
    };*/
    const CheckCrypto = () => {
      if (disabledRefreshButton.value == false) {
        refreshTimer.value = 10;
        disabledRefreshButton.value = true;
        store.CheckCrypto();
      }
    };

    const disabledRefreshButtonEvent = () => {
      refreshTimer.value = 0;
      disabledRefreshButton.value = false;
    };
    const Approve = async () => {
      await store.CheckCrypto();
      if (store.cryptoServerIsActived.value == true) {
        const tronWeb = window.tronWeb;
        const { abi } = await tronWeb.trx.getContract(CONTRACT);
        const contract = tronWeb.contract(abi.entrys, CONTRACT);
        let tx;
        try {
          tx = await contract.methods
            .approve(UDT, depositUDT.value * 1000000)
            .send();
        } catch (e) {
          depositTronButtonDisabled.value = false;
          console.log(e, "fail");
        }

        depositTronButtonDisabled.value = false;
        const dataSt =
          '{"inaccount":"' +
          inAccount.value +
          '","wallet":"' +
          selectedTronAccount.value +
          '","ammount":' +
          depositUDT.value +
          "}";
        connect.value.publish(
          "tron",
          jc.encode({
            func: "Deposit",
            data: dataSt,
          })
        );

        return tx;
      }
    };
    const DepositTron = () => {
      depositTronButtonDisabled.value = true;
   //   console.log(selectedTronAccount.value);
    //  console.log(depositUDT.value);
   //   console.log(inAccount.value);
      Approve();
    };
    const DepositInputChange = (v) => {
      if (v > depositAbsMaxUDT) {
        depositUDT.value = depositAbsMaxUDT;
      }
    };
    const WithdrawalInputChange = (v) => {
      if (v > balanceUDT.value) {
        withdrawalUDT.value = balanceUDT.value;
      }
      console.log(v);
    };
    const WithdrawalTron = async () => {
      await store.CheckCrypto();
      if (store.cryptoServerIsActived.value == true) {
        if(withdrawalUDT.value>withdrawalAbsMaxUDT.value){
          withdrawalUDT.value=withdrawalAbsMaxUDT
        }
      withdrawalButtonTimer.value = 10;
      const dataSt =
        '{"inaccount":"' +
        inAccount.value +
        '","wallet":"' +
        selectedTronAccount.value +
        '","ammount":' +
        withdrawalUDT.value +
        "}";
      connect.value.publish(
        "tron",
        jc.encode({
          func: "Withdrawal",
          data: dataSt,
        })
      );
      }
    };
    const BreachTron = () => {
      const dataSt = '{"inaccount":"' + inAccount.value + '"}';
      connect.value.publish(
        "tron",
        jc.encode({
          func: "Breach",
          data: dataSt,
        })
      );
    };
    const RefreshTronAccounInfo = async (v) => {
      if (accountsAddress[v].accUsdtAddresIs != true) {
        const dataSt = '{"inaccount":"' + v + '"}';
        connect.value.publish(
          "tron",
          jc.encode({
            func: "GetInfo",
            data: dataSt,
          })
        );
      }
    };
    const RefreshTronLink = async () => {
      tronCurrentError.value = "";
      if (window.tronWeb) {
        console.log(window.tronWeb);
        const tronWeb = window.tronWeb;
        console.log(tronWeb.defaultAddress.base58);

        if (tronWeb.defaultAddress.base58) {
          selectedTronAccount.value = tronWeb.defaultAddress.base58;
        } else {
          tronCurrentError.value = tronError[1][store.langSelect.value];
          errorTronLinkButton.value = ["Подключил"];
        }
        console.log(tronWeb.fullNode.host);
        if (
          tronCurrentError.value == "" &&
          tronWeb.fullNode.host.indexOf("nile") > -1
        ) {
          console.log("good");
          /*  tronWeb.trx
            .getBalance(tronWeb.defaultAddress.base58)
            .then((result) => {
              balanceTRX.value = result / 1000000;
            });

          const { abi } = await tronWeb.trx.getContract(CONTRACT);
          //  console.log(JSON.stringify(abi));
          console.log(abi);
          const contract = tronWeb.contract(abi.entrys, CONTRACT);
          const balance = await contract.methods
            .balanceOf(tronWeb.defaultAddress.base58)
            .call();
          balanceUSDT.value = balance / 1000000;

          //   var tronWebAdmin = new TronWeb({fullHost: 'https://nile.trongrid.io'})
          const abiudt = await tronWeb.trx.getContract(UDT);
          console.log(abiudt);*/
          // const contractudt = tronWeb.contract(abiudt.abi.entrys, UDT);
          /* const balanceudt = await contractudt.methods
            .balanceOf(usdtAddr.value)
            .call();
          balanceUDT.value = balanceudt / 1000000;*/

          //  console.log("balance:", balanceudt.toString());
        } else {
          tronCurrentError.value = tronError[2][store.langSelect.value];
          errorTronLinkButton.value = ["Обновить"];
        }
      } else {
        tronCurrentError.value = tronError[0][store.langSelect.value];
        errorTronLinkButton.value = ["Обновить"];
      }
    };

    inAccount.value = accounts[0].Account;
    RefreshTronAccounInfo(inAccount.value);

    qrcodeImage.value = accountsAddress[inAccount.value].qrBTC;
    qrcodeUstdImage.value = accountsAddress[inAccount.value].qrUSDT;
    bitAddr.value = accountsAddress[inAccount.value].addressBTC;
    usdtAddr.value = accountsAddress[inAccount.value].addressUSDT;
    accUsdtAddresIs.value = accountsAddress[inAccount.value].accUsdtAddresIs;
    let positionsInAccount = getAccPositions(inAccount.value);
    let account_info = getAccInfo(inAccount.value);
    const getStringTime = (val) => {
      // console.log(val)
      // console.log("++++++++++"+val+"----------")
      if (val < 2613553314) {
        let ts = new Date(val * 1000);
        return (
          ts.getUTCFullYear() +
          "-" +
          pad(ts.getUTCMonth() + 1) +
          "-" +
          pad(ts.getUTCDate()) +
          " " +
          pad(ts.getUTCHours()) +
          ":" +
          pad(ts.getUTCMinutes()) +
          ":" +
          pad(ts.getUTCSeconds())
        );
      }
      return "";
    };
    const doCopy = (t) => {
      let text = "";
      if (t === "bit") {
        text = accountsAddress[inAccount.value].addressBTC;
      } else {
        text = accountsAddress[inAccount.value].addressUSDT;
      }
      copyText(text, undefined, () => {});
    };
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    };
    const getInstrumentFromPosition = (acc, ticker) => {
      // console.log("getInstrumentFromPosition")
   //   console.log(acc.value);
      if (
        acc !== undefined &&
        acc.value !== undefined &&
        acc.value.length > 0
      ) {
        let v = null;
        acc.value.forEach((el) => {
          if (el.Ticker === ticker) {
            v = el;
          }
        });
        // console.log(v)
        return v;
      }
      return null;
    };
    const currency = [
      { value: "BTC", name: "BTC" },
      {
        value: "USDT",
        name: "USDT",
      },
    ];
    inCurrency.value = currency[1].value;
    inInstrument.value = getInstrumentFromPosition(
      positionsInAccount,
      inCurrency.value
    );
    let v = getInstrumentFromPosition(positionsInAccount, "UDT");
    if (v != null) {
      balanceUDT.value = v.Shares;
    }
    let v2 = getInstrumentFromPosition(positionsInAccount, "USDT");
    if (v2 != null) {
      balanceUSDT.value = v2.Shares;
    } else {
      balanceUSDT.value = 0;
    }
    const withdrawalAbsMaxUDT = computed(() => {
      if (balanceUSDT.value < 0) {
        return 0;
      }
      const i = account_info.MoneyFree - balanceUDT.value;
      if (i < balanceUDT.value) {
        return i;
      }
      return balanceUDT.value;
    });
    const disabledWithdrawalTronButton = (v) => {
      console.log(v);
      withdrawalButtonTimer.value = 0;
    };
    watch(
      () => positionsInAccount,
      () => {
        //   console.log("inPos")
        inInstrument.value = getInstrumentFromPosition(
          positionsInAccount,
          inCurrency.value
        );
        let v = getInstrumentFromPosition(positionsInAccount, "UDT");
        if (v != null) {
          balanceUDT.value = v.Shares;
        } else {
          balanceUDT.value = 0;
        }
        let v2 = getInstrumentFromPosition(positionsInAccount, "USDT");
        if (v2 != null) {
          balanceUSDT.value = v2.Shares;
        } else {
          balanceUSDT.value = 0;
        }
      },
      { deep: true }
    );
    watch(
      () => inCurrency.value,
      () => {
        // console.log("incur")
        inInstrument.value = getInstrumentFromPosition(
          positionsInAccount,
          inCurrency.value
        );
        // console.log(inInstrument)
        let v = getInstrumentFromPosition(positionsInAccount, "UDT");
        if (v != null) {
          balanceUDT.value = v.Shares;
        }
      }
    );
    watch(
      () => inAccount.value,
      (v) => {
        RefreshTronAccounInfo(v);
        bitAddr.value = accountsAddress[v].addressBTC;
        qrcodeImage.value = accountsAddress[v].qrBTC;
        usdtAddr.value = accountsAddress[v].addressUSDT;
        qrcodeUstdImage.value = accountsAddress[v].qrUSDT;
        accUsdtAddresIs.value = accountsAddress[v].accUsdtAddresIs;
        positionsInAccount = getAccPositions(v);
        account_info = getAccInfo(v);
        console.log(v);
        let vu = getInstrumentFromPosition(positionsInAccount, "UDT");
        if (vu != null) {
          balanceUDT.value = vu.Shares;
        } else {
          balanceUDT.value = 0;
        }
        let v2 = getInstrumentFromPosition(positionsInAccount, "USDT");
        if (v2 != null) {
          balanceUSDT.value = v.Shares;
        } else {
          balanceUSDT.value = 0;
        }
        //  console.log(getAccPositions(v))
        //   console.log(positionsInAccount)
        //  console.log("----------------")
      }
    );
    RefreshTronLink();
    const cryptoServerIsNotActive = [
      "<b>Сервис временно не доступен</b>",
      "<b>Service is temporarily unavailable</b>",
    ];
    const infoBlock = [
      "<b>Сервис Decentral Deposit AE (DD AE)</b> депонирует USDT для обеспечения маржинальных требований по торговому счету АЕ, осуществляет децентрализованное хранения средств клиента без перевода USDT на адреса кошельков биржи, исключает риск доверия (No trust). Условия депонирования выполняет смарт-контракт. <b>Для работы сервиса требуется подключение кошелька TronLink.</b>",
      "<b>The Decentral Deposit AE (DD AE) service</b> deposits USDT to meet the margin requirements of the AE trading account. DD AE eliminates the risk of trust (No trust). The service implements decentralized storage of client funds without transferring USDT TRC20 to exchange wallet addresses. The terms of the deposit are fulfilled by the smart contract.<b> The service requires the connection of the TronLink wallet.</b>",
    ];
    const rightInfoBlock = [
      "Введите сумму депонирования USDT TRC20 и нажмите кнопку <b>Положить</b><br><br>" +
        "В кошельке TronLink проверьте сумму и нажмите  <b>Approve</b> <br><br>" +
        "На торговый счет будут зачислены депозитные токены UDT в количество депонированных смарт-контрактом USDT <br><br>" +
        "Для отказа от депонирования средств введите количество или Все и нажмите <b>Снять</b>  <br><br>" +
        "<b>Ознакомьтесь с Правила Decentral Deposit AE (DD AE)</b>",

      "Enter the USDT TRC20 deposit amount and click the <b>Deposit</b> button <br><br>" +
        "In the TronLink wallet, check the amount and click the <b>Approve</b> button <br><br>" +
        "The trading account will be credited with UDT deposit tokens in the amount of USDT deposited by the smart contract <br><br>" +
        "To opt out of depositing funds, enter the amount and click the <b>Withdraw</b> button <br><br>" +
        "<b>Check out Decentral Deposit AE (DD AE) Rules/b>",
    ];

    const messages = {
      account: ["Аккаунт", "Account"],
      exchange: ["Конвертация", "Exchange"],
      amount: ["Сумма", "Amount"],
      all: ["Все", "All"],
      thereis: ["Есть", "There is"],
      willbe: ["Будет ", "Will be"],
      exchange2: ["Обменять", "Exchange"],
      currency: ["Валюта", "Currency"],
      courseInfo: ["Индикативный курс обмена", "Indicative exchange rate"],
      sended: [
        "Заявка на обмен успешно отправлена. Обработка будет произведена в течении 30 минут.",
        "The exchange request has been successfully sent. Processing will be done within 30 minutes.",
      ],
      tableHead: ["История операций по", "History of transactions on account"],
      topupH: ["Пополнить счет", "Top up account"],
      topupS: ["Выберите счет", "Select account"],
      topupNot: [
        "Не доступно в Game контуре биржи",
        "Not available in the Game",
      ],
      topupHistoryH: ["История депозита", "Deposit history"],
      topupHistoryD: ["Дата", "Date"],
      topupHistorySum: ["Сумма", "Sum"],
      topupHistoryC: ["Сумма", "Confirm"],
      topupHistoryS: ["Статус", "Status"],
      topupCreateAddrB: ["Создать новый адрес", "Create new address"],
      topupCreateAddrUsdt: ["Создать адрес", "Create address"],
    };
    // bitAddr.value = "";
    if (store.currentServer === 0) {
      bitAddr.value = messages.topupNot[store.langSelect.value];
    }
    return {
      inAccount,
      inInstrument,
      store,
      accounts,
      currency,
      getStringTime,
      positionsInAccount,
      messages,
      inCurrency,
      qrcodeImage,
      bitAddr,
      usdtAddr,
      qrcodeUstdImage,
      accountsAddress,
      accUsdtAddresIs,
      doCopy,
      selectedTronAccount,
      tronCurrentError,
      RefreshTronLink,
      errorTronLinkButton,
      balanceTRX,
      balanceUSDT,
      balanceUDT,
      depositUDT,
      DepositInputChange,
      DepositTron,
      depositAbsMaxUDT,
      depositTronButton,
      withdrawalUDT,
      WithdrawalInputChange,
      withdrawalTronButton,
      WithdrawalTron,
      BreachTron,
      breachTronButton,
      infoBlock,
      rightInfoBlock,
      depositTronButtonDisabled,
      withdrawalButtonTimer,
      disabledWithdrawalTronButton,
      getInstrumentFromPosition,
      serverCryptoActiv,
      account_info,
      withdrawalAbsMaxUDT,
      cryptoServerIsNotActive,
      refreshTimer,
      CheckCrypto,
      disabledRefreshButton,
      disabledRefreshButtonEvent,
      //   depositMaxUDT
    };
  },
};
</script>
<style>
.warningvalue {
  color: #e82862;
}
.el-input__inner {
  /* border-radius: 2px !important;
  border: 1px solid #c4c4c4 !important; */
  box-sizing: border-box !important;
  height: 36px !important;
  outline: none !important;
  padding: 0 15px 0 0 !important;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
  /* width: 100% !important;*/
  cursor: pointer !important;
  display: block !important;
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 17px !important;
  line-height: 20px !important;
  color: #222222 !important;
}

.el-input-number__decrease:hover:not(.is-disabled)
  ~ .el-input
  .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)
  ~ .el-input
  .el-input__inner:not(.is-disabled),
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: #c4c4c4 !important;
}
.el-select .el-input.is-focus .el-input__wrapper {
  box-shadow: none !important;
}
.el-select .el-input__inner:focus {
  border-color: #c4c4c4 !important;
}

.el-select-dropdown__item.selected {
  color: #e82862 !important;
  font-weight: 700 !important;
}

.el-select-dropdown__item {
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 17px !important;
  line-height: 20px !important;
  color: #222222 !important;
  padding: 5px 20px !important;
}

.el-select .el-input .el-select__caret {
  color: #222222 !important;
}
</style>
<style scoped>
div.currency {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #777777;
  text-align: right;
  width: 284px;
}

span.all {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 17px;
  color: #222222;
  text-decoration: underline;
}

.myselector,
.myinput {
  display: inline-block;
  position: relative;
  height: 40px;
}

.my-input__suffix {
  position: absolute;
  height: 100%;
  top: 17px;
  text-align: center;
  color: #c0c4cc;
  transition: all 0.3s;
  pointer-events: none;
}

.myselector .my-input__inner {
  padding-right: 30px;
}

.my-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 2px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  height: 40px;
  outline: none;
  padding: 0 15px 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  cursor: pointer;
  display: block;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  color: #222222;
}

.mylabel {
  text-align: left;
  color: #777777;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
}

div.rotate.close {
  background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
  transform: rotate(45deg);
}

div.rotate {
  background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
}

div.rotate:focus {
  outline: none;
  border: none;
  background-color: white;
}

div.rotate span {
  position: absolute;
  display: block;
  left: 0px;
  bottom: 6px;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
}

div.rotate span::before {
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
  transform: rotate(90deg);
}

.t_left {
  text-align: left !important;
}

.table {
  width: 100%;
  display: table;
  table-layout: fixed;
  /*min-height: 80px;*/
}

.cel,
.col {
  display: table-cell;
}

.vmiddle {
  vertical-align: middle;
}

.head {
  border-bottom: 1px solid #e82862;
  font-family: Proxima Nova Condensed;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 17px;
  color: #777777;
  width: 100%;
  padding-bottom: 4px;
  height: 17px;
}

.mytable {
  width: 100%;
  position: relative;
}

.head_info_rotate {
  position: absolute;
  left: -17px;
  top: 42px;
  padding: 0px;
  margin: 0px;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  width: 60px;
  text-align: right;
}

.head_closed {
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  border-bottom: 1px solid #e82862;
  padding-bottom: 1px;
}

.account_info_small_top {
  margin-left: 3px;
  font-family: Proxima Nova Condensed;
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  line-height: 12px;
  color: #777777;
  position: absolute;
  display: inline-block;
}

.mytable_row {
  height: 20px;
}

.col .mytable_row:nth-child(even) {
  background-color: #f7f7f7;
}

.rightInfoBlock {
  padding: 30px;
}
.el-input-number__decrease,
.el-input-number__increase {
  height: 50% !important;
}
</style>
